import React from "react";

export default function GLM() {
  return (
    <div className="grid grid-cols-1 gap-y-4 items-center justify-center">
      <a
        href="https://github.com/maahin2005"
        target="_blank"
        rel="noopener noreferrer"
        className="ts:text-2xl vs:text-lg"
      >
        <i
          className={`fa-brands fa-github flex justify-center items-center vs:h-8 vs:w-8 ts:h-9 ts:w-9 hover:text-common-red hover:bg-white rounded-full text-white bg-common-red border-2 border-common-red transition-all duration-500`}
        ></i>
      </a>
      <a
        href="https://youtube.com/@mahindev1112?si=TSIbsS6ZY8qr-SIK/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-xl ts:text-xl vs:text-lg"
      >
        <i
          className={`fa-brands fa-youtube flex justify-center items-center vs:h-8 vs:w-8 ts:h-9 ts:w-9 hover:text-common-red hover:bg-white rounded-full text-white bg-common-red border-2 border-common-red transition-all duration-500`}
        ></i>
      </a>
      <a
        href="https://www.instagram.com/mahi_.01112/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-2xl ts:text-2xl vs:text-lg"
      >
        <i
          className={`fa-brands fa-instagram flex justify-center items-center vs:h-8 vs:w-8 ts:h-9 ts:w-9 hover:text-common-red hover:bg-white rounded-full text-white bg-common-red border-2 border-common-red transition-all duration-500`}
        ></i>
      </a>
    </div>
  );
}
